import {isEmpty as _isEmpty} from "lodash";
import * as React from "react";
import { ConsultationPrescriptionItemRequest } from "@curefit/gmf-common";
import { AppConstants, ORION_IMG_URL } from "../../../utils/AppConstants";

export interface FollowUpPlanPDFProps {
    id: string;
    planItem: any;
}

const FollowUpPlanPDFTemplate: React.StatelessComponent<FollowUpPlanPDFProps> = (props: FollowUpPlanPDFProps) => {
    let id = props.id;
    let planItem = props.planItem;
    let itemToIterate = planItem[id];
    return (
        <div id={id} className="prescription-grid-row external-row">
            <div className="prescription-card-content">
                <h4 className="brandon-bold followUp-header"><img src={ORION_IMG_URL + "icons/follow-up-icon.svg"} />FOLLOW UP</h4>
                <div id={`${id}-subsection`} className="prescription-description">
                    {itemToIterate.map((followUp: any, index: number) => {
                        const hasDuration = !_isEmpty(followUp.followUp)
                        return <div className={"followUp-item"} key={index}>
                            <div>
                                {hasDuration && `In ${followUp.followUp.count + " " + AppConstants.FrequencyUnit[followUp.followUp.unit] + `${followUp.followUp.count > 1 ? "s" : ""}`}`}
                                {!_isEmpty(followUp.comment) ? `, ${followUp.comment}` : ""}
                            </div>
                        </div>
                    })}
                </div>
            </div>
        </div>
    )
}

export default FollowUpPlanPDFTemplate;